"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.NavItems = void 0;

var _react = _interopRequireDefault(require("react"));

var _propTypes = _interopRequireDefault(require("prop-types"));

var _gatsby = require("gatsby");

var _components = require("../../components");

var _utils = require("../../utils");

var _contexts = require("../../contexts");

var _navItemsModule = _interopRequireDefault(require("./nav-items.module.scss"));

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var NavItems = function NavItems(_ref) {
  var pages = _ref.pages;
  return /*#__PURE__*/_react.default.createElement("div", {
    className: _navItemsModule.default.wrapper
  }, pages.map(function (page) {
    var id = (0, _utils.getProperty)(page, "id");
    var path = (0, _utils.getProperty)(page, "data.path");
    var title = (0, _utils.getProperty)(page, "data.title");
    var isExternal = (0, _utils.getProperty)(page, "data.isExternal");
    return isExternal ? /*#__PURE__*/_react.default.createElement("a", {
      key: id,
      href: path,
      className: _navItemsModule.default.item,
      rel: "noopener noreferrer"
    }, /*#__PURE__*/_react.default.createElement(_components.Text, {
      size: "sm",
      transform: "uppercase",
      wrapper: "span"
    }, title)) : /*#__PURE__*/_react.default.createElement(_gatsby.Link, {
      key: id,
      to: path,
      className: _navItemsModule.default.item,
      activeClassName: _navItemsModule.default.active
    }, /*#__PURE__*/_react.default.createElement(_components.Text, {
      size: "sm",
      transform: "uppercase",
      wrapper: "span"
    }, title));
  }));
};

exports.NavItems = NavItems;
NavItems.defaultProps = {
  pages: []
};
NavItems.propTypes = {
  pages: _propTypes.default.arrayOf(_contexts.PageType.isRequired).isRequired
};